import React, { Component, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { connect, useDispatch } from 'react-redux'
import { withRouter } from 'react-router'
import MediaQuery from 'react-responsive'
import Sticky from 'react-stickynode'
import classNames from 'classnames'
import { amplitudeSendEvent } from 'cityads-v3/utils/counterUtils'
import { withTranslation } from 'react-i18next'
import i18n from 'cityads-v3/i18n'
import withHooks from 'cityads-v3/decorators/withHooks'
import { useScrollToTop } from 'cityads-v3/hooks/utils'
import { useDialogActions } from "cityads-v3/hooks/dialog"

import {
  clearCouponList,
  getCouponCategories,
  getCouponOffers,
  getCouponSectoring,
  getOfferTags,
  getPromoActionTypes,
  getPromoCouponStatuses,
  getPromoCouponScopes,
  getRegions,
  loadCouponLink,
} from 'cityads-v3/actions/offers'

import {
  getCouponSectors
} from 'cityads-v3/actions/couponSectors'

import {
  getSadukaLanguages
} from 'cityads-v3/actions/language'

import CouponCard from './CouponCard'
import CouponFilters from './CouponFilters'
import CouponsSelectedFilters from './CouponsSelectedFilters'
import ExportPopup from './ExportPopup'
import GeoDialog from './GeoDialog'
import CouponDownloadPopup from './CouponDownloadPopup'
import CouponExportPopup from './CouponExportPopup'
import ViewSelector, { useViewSelector } from 'cityads-v3/components/ViewSelector/ViewSelector'

import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Collapse from '@mui/material/Collapse'
import Paper from '@mui/material/Paper'
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined'

import Balaclava from 'cityads-v3/components/Balaclava'
import EmptyResults from 'cityads-v3/components/EmptyResults'
import ListingPageToolbar from 'cityads-v3/components/ListingPageToolbar/ListingPageToolbar'
import Paginator from 'cityads-v3/components/Paginator/Paginator'
import Table from 'cityads-v3/components/Table'

import {
  usePaginatorActions,
  useCouponFilters,
  useClearFilters,
  CouponFiltersContext
} from './CouponFilters.hooks'

import classes from '../offers/Offers.scss'

import { useOrderKeys, useCouponsTableCols, useGeoDialog, useExportPopup, useTotalText, useCouponExportOfferInfo } from './Coupons.hooks'
import { useDoubleColumnLimit } from '../offers/Offers.hooks'
export const PROMO_ACTION_TYPE_PROMOCODE = 6


@withRouter
@withHooks(props => {
  const dispatch = useDispatch()
  const { setPageLimit, setPage } = usePaginatorActions()
  const [view, setView] = useViewSelector('couponsListView', 'list')
  const [geoDialog, setAndOpenGeoDialog, geoDialogClose, dialogGeos] = useGeoDialog()
  const [showExportPopup, openExportPopup, closeExportPopup, exportPopupType] = useExportPopup()
  const [showDownloadPopup, openDownloadPopup, closeDownloadPopup] = useDialogActions()
  const totalText = useTotalText()
  const getCouponExportOfferInfo = useCouponExportOfferInfo()
  const listRef = useRef(null)
  const doubleColumnLimit = useDoubleColumnLimit()


  useEffect(() => {
    return () => {
      dispatch(clearCouponList())
    }
  }, [dispatch])

  return {
    ...props,
    clearFilters: useClearFilters(),
    couponFilters: useCouponFilters(),
    doubleColumnLimit,
    listRef,
    orderKeys: useOrderKeys(),
    scrollToTop: useScrollToTop(),
    setPage,
    setPageLimit,
    tableCols: useCouponsTableCols({ onCouponGeoClick: setAndOpenGeoDialog }),
    totalText,
    view,
    setView,
    getCouponExportOfferInfo,
    geoDialog,
    geoDialogClose,
    dialogGeos,
    showExportPopup,
    openExportPopup,
    closeExportPopup,
    exportPopupType,
    showDownloadPopup,
    openDownloadPopup,
    closeDownloadPopup,
  }
})
@connect(
  (state, props) => ({
    offers: state.offers.offers.map(id => state.offers.offersById[id]),
    coupons: state.offers.coupons.map(id => state.offers.couponsById[id]),
    couponsById: state.offers.couponsById,
    isLoadingCoupons: state.offers.isLoadingCoupons,
    offerTagsByCode: state.offers.offerTagsByCode,
    regionsById: state.offers.regionsById,
    language: state.language.language,
    couponOffersById: state.offers.couponOffersById,
    promoActionTypesById: state.offers.promoActionTypesById,
    promoCouponLanguagesById: state.language.sadukaLanguagesById,
    promoCouponScopesById: state.offers.promoCouponScopesById,
    couponLinksByCouponId: state.offers.couponLinksByCouponId,

    user: state.auth.user,

    isMobile: state.app.isMobile,

    metaTotal: state.offers.metaCoupons.total,
    metaLimit: state.offers.metaCoupons.limit,
    metaPage: state.offers.metaCoupons.page,
    withFilters: state.offers.metaCoupons.withFilters,

    isLoadedCouponCategories: state.offers.isLoadedCouponCategories,
    isLoadedRegions: state.offers.isLoadedRegions,
    isLoadedCouponOffers: state.offers.isLoadedCouponOffers,
    isLoadedPromoActionTypes: state.offers.isLoadedPromoActionTypes,
    isLoadedPromoCouponStatuses: state.offers.isLoadedPromoCouponStatuses,
    isLoadedPromoCouponScopes: state.offers.isLoadedPromoCouponScopes,
    isLoadedCouponSectoring: state.offers.isLoadedCouponSectoring,
    isLoadedCouponSectors: state.couponSectors.isLoaded,
    isLoadedPromoCouponLanguages: state.language.isLoadedSadukaLanguages,
    isLoadedOfferTags: state.offers.isLoadedOfferTags,
    isStorageCookieOk: state.auth.isStorageCookieOk,
    isStorageCookieChecked: state.auth.isStorageCookieChecked,
  })
)
@withTranslation(['Offers'], { i18n, wait: !!window })
export default class Coupons extends Component {

  static propTypes = {
    dispatch: PropTypes.func,
    t: PropTypes.func,
    offers: PropTypes.array,
    coupons: PropTypes.array,
    couponsById: PropTypes.object,
    isLoadingCoupons: PropTypes.bool,
    regionsById: PropTypes.object,
    user: PropTypes.object,
    language: PropTypes.string,
    isMobile: PropTypes.bool,
    embedded: PropTypes.bool,
    showSettingView: PropTypes.bool,
    couponOffersById: PropTypes.object,
    promoActionTypesById: PropTypes.object,
    promoCouponLanguagesById: PropTypes.object,
    couponLinksByCouponId: PropTypes.object,

    metaTotal: PropTypes.number,
    metaLimit: PropTypes.number,
    metaPage: PropTypes.number,
    withFilters: PropTypes.bool,

    isLoadedCouponCategories: PropTypes.bool,
    isLoadedRegions: PropTypes.bool,
    isLoadedCouponOffers: PropTypes.bool,
    isLoadedPromoActionTypes: PropTypes.bool,
    isLoadedPromoCouponStatuses: PropTypes.bool,
    isLoadedPromoCouponScopes: PropTypes.bool,
    isLoadedCouponSectors: PropTypes.bool,
    isStorageCookieOk: PropTypes.bool,
    isStorageCookieChecked: PropTypes.bool,
  }

  static defaultProps = {
    showSettingView: true
  }

  state = {}

  componentDidMount(params = this.props) {
    if (!params) {
      params = { ...this.props }
    }

    if (!this.props.isLoadedRegions) { this.props.dispatch(getRegions()) }

    if (!this.props.isLoadedCouponOffers) { this.props.dispatch(getCouponOffers()) }
    if (!this.props.isLoadedCouponSectors) { this.props.dispatch(getCouponSectors()) }
    if (!this.props.isLoadedPromoActionTypes) { this.props.dispatch(getPromoActionTypes()) }
    if (!this.props.isLoadedPromoCouponStatuses) { this.props.dispatch(getPromoCouponStatuses()) }
    if (!this.props.isLoadedPromoCouponScopes) { this.props.dispatch(getPromoCouponScopes()) }
    if (!this.props.isLoadedPromoCouponLanguages) { this.props.dispatch(getSadukaLanguages()) }
    if (!this.props.isLoadedCouponSectoring) { this.props.dispatch(getCouponSectoring()) }

    if (!this.props.isLoadedCouponCategories) { this.props.dispatch(getCouponCategories()) }

    if (!this.props.isLoadedOfferTags) { this.props.dispatch(getOfferTags()) }

    amplitudeSendEvent('makeActions', 'd-v1-e14', 'goods', 'tab_view', { tab_name: 'coupons' })
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const oldProps = this.props
    const { dispatch } = newProps

    const isLanguageChanged = newProps.language && oldProps.language !== newProps.language

    if (isLanguageChanged) {
      setTimeout(() => {
        dispatch(getRegions())
        dispatch(getCouponCategories())
        dispatch(getCouponOffers())
        dispatch(getCouponSectoring())
        dispatch(getOfferTags())
      }, 10)
    }

    if (isLanguageChanged || storageCookieChanged(oldProps, newProps)) {
      setTimeout(() => {
        dispatch(getPromoActionTypes())
        dispatch(getPromoCouponStatuses())
        dispatch(getSadukaLanguages())
        dispatch(getCouponSectors())
        dispatch(getPromoCouponScopes())
      }, 10)
    }
  }

  onRowClick = (row, evt) => {
    if (evt.defaultPrevented) {
      return
    }

    const { dispatch } = this.props

    dispatch(loadCouponLink(row.id))
    this.setState({
      couponIdForExportPopup: row.id
    });
  }

  render() {
    let couponList
    let tableList

    const {
      t,
      embedded,
      couponFilters,
      view,
      setView,
      forceView,
      orderKeys,
      tableCols,
      geoDialog,
      geoDialogClose,
      dialogGeos,
      totalText,
      getCouponExportOfferInfo,
    } = this.props
    const isLoading = this.props.isLoadingCoupons

    const data = this.props.coupons.map(item => {
      return {
        ...item,
      }
    })

    if ((forceView ?? view) === 'list') {
      couponList = data.map((item, num) => (
        <div key={`coupon-${item.id}`} className={classes.offers__listItem}>
          <CouponCard {...item} linkSource={'coupons'} key={`coupon-${item.id}`} />
        </div>
      ))
    } else {
      data.forEach(item => {
        item._style = {
          backgroundColor: item.is_exclusive
            ? (this.props.offerTagsByCode.exclusive?.offer_bg_color)
            : null,
        }
        item.classes = item.is_exclusive ? { root: classes.tableRowExclusive } : null
      })

      const promoActionType = this.props.couponsById?.[this.state.couponIdForExportPopup]?.promo_action_type

      tableList = (
        <div className={classes.offers__table}>
          <Table
            cols={tableCols}
            rows={data}
            onRowClick={this.onRowClick}
            paper={true}
            showRowHover={true}
            innerScrollX={true}
          />
          <GeoDialog
            open={geoDialog}
            onClose={geoDialogClose}
          >
            {dialogGeos}
          </GeoDialog>
          <CouponExportPopup
            id={this.state.couponIdForExportPopup}
            promoActionType={promoActionType}
            open={!!this.state.couponIdForExportPopup}
            onRequestClose={() => this.setState({ couponIdForExportPopup: null })}
            {...getCouponExportOfferInfo(this.state.couponIdForExportPopup)}
          />
        </div>
      )
    }


    const notFound = data.length === 0 && isLoading === false ? (
      <EmptyResults
        icon={<FilterListOutlinedIcon />}
        emptyText={t('emptyResults')}
        actions={<Button onClick={couponFilters.clearFilters.bind(this)}>{t('resetFilters')}</Button>}
      />
    ) : false

    const toolbar = (
      <ListingPageToolbar
        orderKeys={orderKeys}
        selectedSort={couponFilters.selectedFilters.fields.order.value}
        onChangeSort={couponFilters.handleChangeOrder.bind(this)}
        viewComponent={<ViewSelector value={forceView ?? view} onChange={setView} />}
        totalText={totalText}
        exports={this.getExportsConfigCoupons()}
      />
    )

    return (
      <CouponFiltersContext.Provider value={couponFilters}>
        <div className={classes.offers} id="couponsContent">
          {embedded ?
            null :
            (
              <>
                <Helmet
                  title={t('main:header.coupons')}
                  meta={[
                    { name: 'description', content: t('description') },
                    { name: 'keywords', content: t('keywords') },
                  ]}
                />

                <Balaclava
                  title={t('main:header.coupons')}
                />
              </>
            )
          }

          <MediaQuery minWidth={this.props.doubleColumnLimit}>
            {(isDoubleColumn) => (
              <>
                {isDoubleColumn ? toolbar : null}

                <div className={classes.offersWrapper}>
                  <div className={classes.offersSidebar}>
                    <Sticky
                      enabled={isDoubleColumn}
                      top={'#header'}
                      bottomBoundary="#couponsContent"
                    >
                      <CouponFilters />
                    </Sticky>
                  </div>

                  {isDoubleColumn ?
                    null :
                    (
                      <div className={classes.offersToolbarColumn}>
                        {toolbar}
                      </div>
                    )
                  }

                  <div className={classes.offersMainColumn}>
                    <CouponsSelectedFilters />

                    <div ref={this.props.listRef}>
                      <Collapse in={isLoading} mountOnEnter unmountOnExit className={classes.offersProgressWrapper}>
                        <CircularProgress size={40} className={classes.offersProgress} />
                      </Collapse>

                      <div className={classNames(classes.offers__list, { [classes.offers__list__away]: isLoading })} ref={this.props.listRef}>
                        {data.length && !isLoading ? (
                          <div className={classes.totalText}>{totalText}</div>
                        ) : null}
                        {data.length ? (forceView ?? view) === 'list' ? couponList : tableList : false}
                        {notFound}
                      </div>
                    </div>

                    {data.length ?
                      <Paper>
                        <div className={classNames.paginator}>
                          <Paginator
                            count={Math.ceil(this.props.metaTotal)}
                            page={this.props.metaPage}
                            rowsPerPage={this.props.metaLimit}
                            onPageChange={(evt, page) => {
                              this.props.scrollToTop?.()
                              this.props.setPage(page)
                            }}
                            onRowsPerPageChange={this.props.setPageLimit.bind(this)}
                          />
                        </div>
                      </Paper>
                      :
                      false
                    }

                    <React.Fragment>
                      <ExportPopup
                        open={this.props.showExportPopup}
                        onRequestClose={this.props.closeExportPopup}
                        exportPopupType={this.props.exportPopupType}
                      />

                      <CouponDownloadPopup
                        open={this.props.showDownloadPopup}
                        onRequestClose={this.props.closeDownloadPopup}
                      />
                    </React.Fragment>
                  </div>
                </div>
              </>
            )}
          </MediaQuery>
        </div>
      </CouponFiltersContext.Provider>
    )
  }

  getExportsConfigCoupons() {
    const { t, openExportPopup, openDownloadPopup } = this.props

    return {
      title: t('exports.title'),
      items: [{
        title: t('exports.export'),
        icon: 'file_download',
        closeAfterClick: true,
        onClick: openDownloadPopup
      }, {
        type: 'divider',
        title: t('exports.getLink')
      }, {
        title: 'json',
        icon: 'link',
        closeAfterClick: true,
        onClick: () => {
          openExportPopup('json')
        }
      }, {
        title: 'xml',
        icon: 'link',
        closeAfterClick: true,
        onClick: () => {
          openExportPopup('xml')
        }
      }]
    }
  }
}

function storageCookieChanged(oldProps, newProps) {
  return oldProps.isStorageCookieOk !== newProps.isStorageCookieOk ||
    oldProps.isStorageCookieChecked !== newProps.isStorageCookieChecked
}
